import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { BrdsqlService } from 'src/app/core/services/brdsql.service';
import { NgxSpinnerService } from 'ngx-spinner';
import axios from 'axios';
import { Authenticationservice } from '../../../services/authentication.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-dps-edit',
  templateUrl: './dps-edit.component.html',
  styleUrls: ['./dps-edit.component.css']
})
export class DpsEditComponent implements OnInit {
  @ViewChild('table') table: ElementRef;
  //@ViewChild('tb_data1') tb_data1!: ElementRef;

  zone = '';
  supcode = '';
  userlv = '';
  supname = '';
  canEdit = false;
  constructor(
    private brdservice: BrdsqlService,
    private spinner: NgxSpinnerService,
    private auth: Authenticationservice,
  ) {
    let userdata;
    userdata = this.auth.Authention();
    this.zone = userdata.zonedata;
    this.supcode = userdata.supcode;
    this.userlv = userdata.userlevel
    this.supname = userdata.supname

    if (userdata.supcode.substring(0, 1) == '8') this.canEdit = true
    else this.canEdit = false
    console.log('userdata:', userdata)
  }

  ngOnInit(): void {
    this.ckSetup()
  }
  edit_st = 0;

  ExportExcel() {
    let options: any = {
      year: "numeric", month: "short", day: "numeric", hour: "2-digit", minute: "2-digit"
    };
    var currentDate = new Date();
    var dateLOC = currentDate.toLocaleString('th-TH', options);

    let name = ''
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(this.table.nativeElement);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    /* save to file */
    XLSX.writeFile(wb, `ข้อมูลส่งอ้อย-${name}_${dateLOC}.xlsx`);
  }

  // ตรวจสอบว่า สามารถทำรายการฝากหักได้หรือไม่
  canDeposit = false
  ckSetup() {
    this.brdservice.ckCanDeposit().subscribe({
      next: (res: any) => {
        if (res.recordset[0].setup == "Y") {
          this.canDeposit = true
        }
        else this.canDeposit = false
      }
    })
  }

  val_f: any
  // ข้อมูลการส่งอ้อยจากเงื่อนไข
  cpcData?: any[] = []
  async getCpcData(f: any) {
    this.val_f = f;
    this.spinner.show();
    this.cpcData = []
    // console.log('form ', f)
    await this.brdservice.getCpcData(f).subscribe({
      next: (res: any) => {
        this.spinner.hide();
        let data = res
        if (data.length > 0) {
          const trimData = data.map(item => {
            const trimmedItem = {};
            for (const key in item) {
              if (item.hasOwnProperty(key) && typeof item[key] === 'string') {
                trimmedItem[key] = item[key].trim();
              } else {
                trimmedItem[key] = item[key];
              }
            }
            return trimmedItem;
          });
          let data2 = trimData.map(item => {
            const ck_truck = item.FMCODE == item.OWNCODE;//เช็คว่าเจ้าของรถบรรทุกตรงกับเจ้าของอ้อยหรือไม่
            const ck_cut = false;//item.FMCODE == item.OWNCODE_CUT;//เช็คว่าเจ้าของรถตัดตรงกับเจ้าของอ้อยหรือไม่
            const ck_keep = false;//item.FMCODE == item.OWNCODE_KEEP;//เช็คว่าเจ้าของรถคีบตรงกับเจ้าของอ้อยหรือไม่
            return { ...item, modify: false, ck_truck, ck_cut, ck_keep };
          });
          this.edit_st = 0;
          this.cpcData = data2
          // console.log('res ', res.recordset)
          /* setTimeout(() => {
             $(this.tb_data1.nativeElement).DataTable();
           }, 0);*/

        }
      }
    })
  }

  async saveData() {
    let data = this.cpcData.filter((el: any) => el.modify == true);
    console.log('modify:', data);
    if (data.length > 0) {
      if (confirm(`ต้องการบันทึกข้อมูล | จำนวน ${data.length} แถว หรือไม่?`)) {
        this.spinner.show();
        for (let i = 0; i < data.length; i++) {
          let ar0 = data[i];
          this.UpdateCPC(ar0, i);
          await new Promise(resolve => setTimeout(resolve, 500));
        }
        this.spinner.hide();
        alert("บันทึกข้อมูลแล้ว");
        setTimeout(() => {
          this.getCpcData(this.val_f);
        }, 500);
      }
    }
    else alert("ยังไม่มีการแก้ไขข้อมูล");
  }

  UpdateCPC(data, i: number) {
    let d = data;
    let url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbbrr/update_CPC_TRUC?[TRUCK_Q]='${d.TRUCK_Q}'&[truck_no]='${d.truck_no}'&[regtruck]='${d.regtruck}'&OWNCODE='${d.OWNCODE}'&TRUCK_FEE=${d.TRUCK_FEE} 
    &[CUT_NO]='${d.CUT_NO}'&[OWNCODE_CUT]='${d.OWNCODE_CUT}'&[CUT_RATE]=${d.CUT_RATE}&[keep_no]='${d.keep_no}'&[OWNCODE_KEEP]='${d.OWNCODE_KEEP}'&[KEEP_RATE]=${d.KEEP_RATE}&[userzone]='${this.supcode}'&[DateUpdateZone]=GETDATE()`;
    //console.log('url UpdateCPC: ', i, ' : ', url);
    axios.post(url).then(res => {
      if (res.data.rowsAffected[0] >= 1) {
      }
      else {
        alert('อัพเดทข้อมูล ไม่สำเร็จ');
      }
    }).catch(err => { throw err })

  }


  selectedOption: string;
  userSelect: string
  showLabel: string
  getLabel() {
    this.userSelect = this.selectedOption;
    // console.log('select ', this.userSelect)
    switch (this.userSelect) {
      case "1": this.showLabel = "ป้อนรหัสกลุ่มรถตัด"
        break;
      case "2": this.showLabel = "ป้อนบช.เจ้าของรถบรรทุก"
        break;
      case "3": this.showLabel = "ป้อนบช.เจ้าของอ้อย"
        break;
      case "4": this.showLabel = "ป้อนรหัสกลุ่มตัด"
        break;
      case "5": this.showLabel = "ป้อนทะเบียนรถบรรทุก"
        break;
      case "6": this.showLabel = "ป้อนเบอร์รถคีบ"
        break;
      default: this.showLabel = "..."
        break;
    }
  }

  truck_qData?: any = []
  truck_qSelect?: string = ""
  cpcSelect(truck_q: string) {
    this.truck_qSelect = truck_q
    this.truck_qData = this.cpcData.filter((el: { truck_q: any; }) => el.truck_q == truck_q);
    this.truck_qData = this.truck_qData[0];
    // console.log('truck_q after filter ',this.truck_qData)
  }

  savefalse = false
  async saveDeposit(f: any) {
    console.log('form ', f)
    await this.brdservice.saveDeposit(f).subscribe({
      next: (res: any) => {
        console.log('res save ', res)
        // if(res.rowsAffected[0] !==0) {
        //   alert('บันทึกข้อมูลแล้ว')
        // } else {
        //   this.savefalse = true
        // }
      }
    })
  }

}
